import { useMemo } from 'react';
import dayjs from 'dayjs';

import { END_OF_QUARTER_MONTHS, DATE_PERIOD_FORMAT, REVERSE_DATE_FORMAT } from 'constants-module';
import { capitalize } from 'helpers';
import { useFetchPeriodsQuery } from 'services';
import { getLanguage } from 'store';
import { useAppSelector } from 'hooks';

export const useEndOfQuarterPeriods = () => {
  const { data: periods } = useFetchPeriodsQuery();
  const language = useAppSelector(getLanguage);

  return useMemo(() => {
    const options = periods?.filter((item) => {
      return END_OF_QUARTER_MONTHS.includes(item.month) && item.isActive === true;
    });

    return options
      ?.sort((a, b) => a.month - b.month)
      ?.sort((a, b) => a.year - b.year)
      .map((item) => {
        const period = dayjs(new Date(item.year, item.month - 1)).locale(language);

        return {
          label: capitalize(period.format(DATE_PERIOD_FORMAT)),
          value: period.format(REVERSE_DATE_FORMAT),
        };
      });
  }, [language, periods]);
};
